import React, { Fragment } from "react";

import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import NullChip from "../chips/NullChip";

const useStyles = makeStyles(theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  },
  paperTable: {
    width: "100%",
    overflowX: "auto",
    marginBottom: theme.spacing(2),
    backgroundColor: "#212121"
  }
}));

export default function GoogleDataPanel({ geoTypes, geoDetails }) {
  const classes = useStyles();
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="loc-geo-content"
        id="loc-geo-header"
      >
        <Typography className={classes.heading}>
          Google Data (For Reference Only)
        </Typography>
      </AccordionSummary>
      <AccordionDetails style={{ display: "block" }}>
        {(geoTypes || geoDetails) && (
          <Fragment>
            {geoTypes && (
              <Box display="block">
                <Typography variant="caption" display="block" gutterBottom>
                  Geo Types
                </Typography>
                <Box>
                  {geoTypes.map(type => {
                    return (
                      <Chip
                        key={type.geoTypeId}
                        size="small"
                        label={type.geoType}
                        style={{ marginRight: "10px", marginBottom: "10px" }}
                      />
                    );
                  })}
                </Box>
              </Box>
            )}
            {geoDetails && (
              <Box display="block" style={{ marginTop: "10px" }}>
                <Typography variant="caption" display="block" gutterBottom>
                  Address Components
                </Typography>
                <Paper className={classes.paperTable}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Type</TableCell>
                        <TableCell>Sub Type</TableCell>
                        <TableCell>Long Name</TableCell>
                        <TableCell>Short Name</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {geoDetails.map(component => {
                        return (
                          <TableRow key={component.geoDetailsId}>
                            <TableCell>{component.geoType}</TableCell>
                            <TableCell>
                              {!!component.subType ? (
                                component.subType
                              ) : (
                                <NullChip />
                              )}
                            </TableCell>
                            <TableCell>{component.longName}</TableCell>
                            <TableCell>{component.shortName}</TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Paper>
              </Box>
            )}
          </Fragment>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
